module.exports = __webpack_public_path__ + "static/media/IKMS01.69a90fa9.jpg";